import React from "react";

import { useTranslate } from "localization";
import { Filter } from "ui/forms";

import { useSubmissionGroupsFilterQuery } from "API";

import useFilterParam from "./useFilterParam";

const SubmissionGroup: React.FC<{
  customTitle?: string;
}> = ({ customTitle }) => {
  const { translate } = useTranslate();
  const title = translate(customTitle || "group");

  const { data = [], isSuccess, isError } = useSubmissionGroupsFilterQuery();
  const [selected, setSelected] = useFilterParam("submissionGroup", data, {
    defaultToFirst: false,
    multi: true,
    ready: isSuccess || isError,
  });
  return (
    <Filter
      items={{ options: data }}
      title={title}
      label={title}
      selected={!!selected.length}
      count={selected.length ? selected.length : void 0}
      onChange={setSelected}
      disabled={!isSuccess}
      value={selected}
      multi={true}
      showReset={true}
      showApply={true}
      searchable={true}
      translate={translate}
    />
  );
};

export default SubmissionGroup;
